import React from 'react';

export const Card = ({ children, className = '', hover = true }) => {
  return (
    <div className={`
      bg-white rounded-2xl p-8 md:p-10 border border-warm-stone/30
      transition-all duration-300
      ${hover ? 'hover:shadow-float hover:-translate-y-1' : 'shadow-soft'}
      ${className}
    `}>
      {children}
    </div>
  );
};